module.exports = function() {
  return new Worker("./" + "coffee-transpiler.8717ccb8.worker.js");
};